<template>
	<div id="app">
		<router-view :key="$route.fullPath" />
	</div>
</template>

<script>
import Vue from "vue";

import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";

import "@/assets/css/apply.css";
import "@/assets/css/app.css";

import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", VueSelect);

// Global components
import Loading from "@/components/global/Loading";
Vue.component("loading", Loading);

import "material-icons/iconfont/material-icons.css";

import MainPage from "@/components/MainPage";
Vue.component("main-page", MainPage);

// Plugins
import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);
import VueTippy from "vue-tippy";
Vue.use(VueTippy, {
	arrow: true,
	arrowType: "sharp",
	// duration: [350, 100000]
	// theme: "gradient"
});
import VueLocalStorage from "vue-localstorage";
Vue.use(VueLocalStorage, { name: "ls", namespace: "mzd-steminn" });

import BrandService from "@/services/BrandService";
var brand = BrandService.getBrand();
BrandService.loadCSS(brand);
BrandService.setTitle(brand);

export default {
	name: "App",
	components: {},
};
</script>

<style>
</style>
